module.exports = __webpack_public_path__ + "static/podcast-teaser-mobile.d35a008f.webp";